import { FINDER_ENTRY_PATH } from '@/shared/config/funnel/flowConstants';

const SLUG_SEGMENT_PATTERN = '[a-z0-9-]+';
const ESCAPED_FINDER_ENTRY_PATH = FINDER_ENTRY_PATH.replace(/\//g, '\\/');
const CARD_FINDER_BACK_TO_PATH = new RegExp(
  `^${ESCAPED_FINDER_ENTRY_PATH}(?:/(${SLUG_SEGMENT_PATTERN})(?:/(${SLUG_SEGMENT_PATTERN}))?)?$`,
);

/** Accepts in-app cardfinder paths: entry, entry/branch, or entry/branch/step. */
export function sanitizeBackToPath(backTo: string | null | undefined): string | null {
  if (!backTo) return null;
  if (!backTo.startsWith('/') || backTo.startsWith('//')) return null;

  const queryOrHashIndex = backTo.search(/[?#]/);
  const pathname = queryOrHashIndex === -1 ? backTo : backTo.slice(0, queryOrHashIndex);
  const suffix = queryOrHashIndex === -1 ? '' : backTo.slice(queryOrHashIndex);

  const normalizedPath =
    pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;

  if (!CARD_FINDER_BACK_TO_PATH.test(normalizedPath)) return null;

  return `${normalizedPath}${suffix}`;
}

/**
 * Where `goBack` should land when there is no earlier step within the current
 * branch (i.e. at the branch's first step): the sanitized `backTo` query param
 * if present and valid, otherwise the funnel root — going further back from a
 * branch's first step always means returning to primary_goal.
 */
export function resolveBranchEntryBackTo(rawBackTo: string | null | undefined): string {
  return sanitizeBackToPath(rawBackTo) ?? FINDER_ENTRY_PATH;
}
